import {RefObject, useEffect} from 'react';
import {useEventCallback} from './useEventCallback';

type Size = {width: number; height: number};

export const useResizeObserver = (ref: RefObject<HTMLElement>, onResize: ((size: Size) => void) | undefined) => {
  const handleResize = useEventCallback(onResize);

  useEffect(() => {
    const element = ref.current;
    if (element === null || handleResize === undefined || globalThis.ResizeObserver === undefined) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      const {width, height} = entry.contentRect;
      handleResize({width, height});
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, handleResize]);
};
